import React from 'react'
import '../App.css'
import { Button } from './Button'
import'./HeroSection.css'

function HeroSection() {

  const openPdf = () => {
    const pdfPath = './resume.pdf';
    
    window.open(pdfPath, '_blank');
  };

  return (
    <div className='hero-container'>
        <video src='/videos/websiteBackground.mp4' autoPlay loop muted />
        <h1>Dylan Frajerman</h1>
        <p>My Website Portfolio</p>
        <div className='hero-btns'>
            <Button 
            className='btns'
            to='/about-me' 
            buttonStyle='btn--outline'
            buttonSize='btn--large'
            >
                About Me
            </Button>
            <Button 
            className='btns' 
            buttonStyle='btn--primary'
            buttonSize='btn--large'
            onClick={openPdf}
            >
                My Resume
            </Button>
        </div>
    </div>
  )
}

export default HeroSection
